import { GraphQLNonNull } from 'graphql'
import { ATOAttackInterval, ATOAttackIntervalType } from './ato-attack-interval'

export interface ATOAttackQueryArgs {
  readonly interval: ATOAttackIntervalType
}

export const atoAttackQueryArgs = {
  interval: {
    description: 'The time interval of attack data to be queried',
    type: new GraphQLNonNull(ATOAttackInterval)
  }
}
